export const ROUTES = {
  home: '/',
  event: 'event/:eventKey',
  checkout: 'checkout',
  summary: 'summary',
  summarySuccess: 'summary/success',
  summaryCancel: 'summary/cancel',
  summaryFailed: 'summary/failed',
  featureflag: 'featureflags',
  ticketGenerator: 'ticket-generator/:ticketId',
  b2bLanding: '/b2b',
  b2bRegistration: '/b2b/register',
  b2bRegistrationSuccess: '/b2b/register/success',
  termsOfUse: 'terms-of-use',
  aboutUs: 'about-us',
  profile: 'profile',
  history: 'history',
  concerts: 'concerts',
  singleConcert: 'concert/:eventKey',
  internationalEvents: 'international-events',
  internationalEventsCountry: 'international-events/:country',
  internationalEvent: 'international-event/:eventKey',
  matches: '/matches',
  workshops: '/workshops',
  test: 'test',
  maintenance: 'maintenance',
  invitation: 'invitation/:invitationId',
} as const;

/** All URL paths that render the order summary flow (same page; pathname drives analytics). */
export const ORDER_SUMMARY_PATHS = [
  ROUTES.summary,
  ROUTES.summarySuccess,
  ROUTES.summaryCancel,
  ROUTES.summaryFailed,
] as const;

/** `/b2b`, `/b2b/register`, `/b2b/register/success`, etc. — the organizer (B2B) section. */
export const isB2bShellRoutePathname = (pathname: string): boolean =>
  pathname === ROUTES.b2bLanding || pathname.startsWith(`${ROUTES.b2bLanding}/`);
